import {
  clearEntities,
  updateTables,
} from 'containers/Entity/actions'
import {
  CLEAR_PRODUCT_LIST,
  UPDATE_INPUT_VALUE,
  UPDATE_SEGMENT_LIST,
  UPDATE_LINE_LIST,
  UPDATE_PRODUCT_SKUS,
  TOGGLE_POPUP,
  FETCH_SEGMENT_LINE,
  FETCH_SEGMENT_LINE_START,
  FETCH_SEGMENT_LINE_SUCCESS,
  FETCH_SEGMENT_LINE_ERROR,
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
  POST_FORM,
  POST_FORM_START,
  POST_FORM_SUCCESS,
  POST_FORM_ERROR,
} from './constants'
import {
  get,
} from 'helpers/RequestUtil'
import {
  error
} from 'containers/App/Notification/actions'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const productListUrl = '/api/fulcrum/product/lists'
const requestProductList = (query) => {
  let url = productListUrl

  if (query)
    url = `${productListUrl}?filter[search]=${query}`

  return get(url)
}

const clearProductList = () => {
  return {
    type: CLEAR_PRODUCT_LIST
  }
}

export const updateInputValue = (value) => {
  return {
    type: UPDATE_INPUT_VALUE,
    value
  }
}

export const onEnterPress = (event) => {
  return dispatch => {
    const {
      key,
      target: {
        value
      }
    } = event
    let promise = Promise.resolve(null)
    if (key === 'Enter')
      promise = dispatch(getProductList(value))
    return promise
  }
}

export const getProductList = (query) => {
  return dispatch => {
    dispatch(clearEntities())
    return requestProductList(query)
      .then(data => dispatch(updateTables(data)))
      .catch(e => dispatch(error('Failed to get products.')))
  }
}

export const initializeProductList  = () => {
  return (dispatch, getState) => {
    dispatch(clearProductList())
    dispatch(fetchSegmentLine())
    return dispatch(getProductList())
  }
}

const fetchSkus = (segment, line) => ({ type: FETCH_PRODUCT_SKUS, segment, line })
const fetchSkusStart = (id) => ({ type: FETCH_PRODUCT_SKUS_START, id })
const fetchSkusSucess = (id) => ({ type: FETCH_PRODUCT_SKUS_SUCCESS })
const fetchSkusError = (error) => ({ type: FETCH_PRODUCT_SKUS_ERROR, error })

const fetchSegmentLine = () => ({ type: FETCH_SEGMENT_LINE })
const fetchSegmentLineStart = () => ({ type: FETCH_SEGMENT_LINE_START })
const fetchSegmentLineSuccess = () => ({ type: FETCH_SEGMENT_LINE_SUCCESS })
const fetchSegmentLineError = (error) => ({ type: FETCH_SEGMENT_LINE_ERROR, error })

const postForm = (productDetails) => ({ type: POST_FORM, productDetails: productDetails })
const postFormStart = () => ({ type: POST_FORM_START })
const postFormSuccess = () => ({ type: POST_FORM_SUCCESS })
const postFormError = (error) => ({ type: POST_FORM_ERROR, error })

const updateSegmentList = (data) => ({ type: UPDATE_SEGMENT_LIST, segments: data })
const updateLineList = (data) => ({ type: UPDATE_LINE_LIST, lines: data })
const updateProductSkus = (data) => ({ type: UPDATE_PRODUCT_SKUS, products: data })

const onTogglePopup = (value) => ({ type: TOGGLE_POPUP, value })

export {
  fetchSkus,
  fetchSkusStart,
  fetchSkusSucess,
  fetchSkusError,
  fetchSegmentLine,
  fetchSegmentLineStart,
  fetchSegmentLineSuccess,
  fetchSegmentLineError,
  updateSegmentList,
  updateLineList,
  updateProductSkus,
  onTogglePopup,
  postForm,
  postFormStart,
  postFormSuccess,
  postFormError,
}